import { Usuario } from "./usuario.model";

export class Login {

    auth: string;
    token: string;
    user: Usuario;

}